import { SET_CUT_NODE } from "redux/constants/flowDesigner";
import {
   SET_FLOW_BY_ID,
   SET_SAVED_FLOW,
   SET_SAVING_FLOW_FLAG_SUCCESS,
   SET_SAVING_FLOW_FLAG_RESET,
   CLEAR_CURRENT_SAVED_FLOW,
   CLEAR_FLOW,
   SET_AUTO_SAVING_FLOW_FLAG_SUCCESS,
   SET_AUTO_SAVING_FLOW_FLAG_RESET,
   SET_SAVING_FLOW_PROPERTIES_FLAG_RESET,
   SET_SAVING_FLOW_PROPERTIES_FLAG_SUCCESS,
   SET_FLOW,
   UPDATE_FLOW_STEPS,
   SET_CANVAS_FLOW_INSTANCE,
   RELOAD_FLOW,
   AUTO_SAVE_ON_CANCEL_RESET,
   START_DRAG_COMPONENT,
   STOP_DRAG_COMPONENT,
   OPEN_FLOW_LIST_DIALOG,
   CLOSE_FLOW_LIST_DIALOG,
   SET_NEW_TAB_FLAG,
   OPEN_RECENT_ACTIVITIES_DIALOG,
   CLOSE_RECENT_ACTIVITIES_DIALOG,
   SET_SHARE_FLOW_FLAG_RESET,
   SET_SHARE_FLOW_FLAG_SUCCESS,
   SET_SCHEDULED_FLOW_FLAG,
   ADD_FLOW_VARIABLE,
   DELETE_FLOW_VARIABLE,
   UPDATE_FLOW_VARIABLE,
   SET_FLOW_VARIABLES,
   OPEN_DUPLICATE_FLOW_DIALOG,
   CLOSE_DUPLICATE_FLOW_DIALOG,
   SET_NUMBER_OF_NODES_LIMIT_REACHED,
   SET_COPIED_NODE,
   SET_IS_NOTES_DIALOG_OPEN,
   SET_NODE_TO_ADD_NOTES,
   SET_DRAGGED_NODE,
   SET_USER_COMMENTS,
   SET_IS_LOADING_USER_COMMENTS,
   SET_DESIGNER_USER_FLOWS,
   UPSERT_DESIGNER_USER_FLOWS,
   REMOVE_DESIGNER_USER_FLOWS,
   SET_DESIGNER_FLOWS,
   SET_FLOW_VERSIONS,
   SET_FLOW_VERSIONS_IS_LOADING,
   SET_FLOW_IS_LOADING,
   RELOAD_FLOWS,
   SET_FLOW_VERSIONS_DIALOG_OPEN,
   SET_CREATE_FLOW_VERSION_DIALOG_OPEN,
   SET_DELETE_FLOW_VERSION_DIALOG_OPEN,
   SET_FLOW_VERSION_TO_DELETE,
   SET_CHANGE_FLOW_VERSION_DIALOG_OPEN,
   SET_FLOW_VERSION_TO_USE,
   SET_IS_CHANGING_FLOW_MODE,
   SET_FLOW_CONFIGURATION,
   SET_SHARED_FLOW_CONFIGURATIONS
} from "redux/constants/flowDesigner";

const initialState = {
   flowById: null,
   currentSavedFlow: null,
   flow: {
      name: "",
      description: "",
      notes: "",
      variables: {},
      sensitiveData: [],
      steps: []
   },
   flowVariables: {},
   savingFlowFlagSuccess: false,
   autoSavingFlowFlagSuccess: false,
   savingFlowPropertiesFlagSuccess: false,
   shareFlowFlagSuccess: false,

   showDuplicateFlowDialog: false,
   isNewTab: false,
   showFlowListDialog: false,
   showRecentActivitiesDialog: false,
   autoSaveOnCancel: false,
   canvasFlowInstance: {},

   reloadFlowCount: 0,
   flows: [],
   userFlows: [],
   dragInProgress: false,
   isScheduledFlow: false,
   numberOfNodesLimitReached: false,
   popupOpenMenu: true,
   copiedNode: null,
   cutNode: null,
   isNotesDialogOpen: false,
   nodeToAddNotes: null,
   draggedNode: null,
   user_comments: [],
   isLoadingUserComments: false,
   credentialsInSharedFlow: [],
   flowVersions: [],
   isFlowVersionsIsLoading: false,
   isFlowLoading: false,
   reloadFlowsCount: 0,

   flowVersionsDialogOpen: false,
   createFlowVersionDialogOpen: false,
   deleteFlowVersionDialogOpen: false,
   flowVersionToDelete: null,
   changeFlowVersionConfirmationDialogOpen: true,
   flowVersionToUse: null,
   isChangingFlowMode: false,
   flowConfiguration: {},
   sharedFlowConfigurations: {}
};

const flows = (state = initialState, { type, payload }) => {
   switch (type) {
      case SET_FLOW_VARIABLES:
         return {
            ...state,
            flowVariables: payload
         };
      case ADD_FLOW_VARIABLE:
         return {
            ...state,
            flowVariables: {
               ...state.flowVariables,
               [payload]: []
            }
         };
      case DELETE_FLOW_VARIABLE: {
         const newFlowVariables = { ...state.flowVariables };
         delete newFlowVariables[payload];
         return {
            ...state,
            flowVariables: newFlowVariables
         };
      }
      case UPDATE_FLOW_VARIABLE:
         return {
            ...state,
            flowVariables: {
               ...state.flowVariables,
               [payload.id]: payload.data
            }
         };
      case RELOAD_FLOW:
         return {
            ...state,
            reloadFlowCount: ++state.reloadFlowCount
         };
      case SET_FLOW_BY_ID:
         return {
            ...state,
            flowById: payload
         };
      case SET_SAVED_FLOW:
         return {
            ...state,
            currentSavedFlow: {
               ...state.currentSavedFlow,
               ...payload
            }
         };
      case CLEAR_CURRENT_SAVED_FLOW:
         return {
            ...state,
            currentSavedFlow: null
         };
      case SET_SAVING_FLOW_FLAG_SUCCESS:
         return {
            ...state,
            savingFlowFlagSuccess: true
         };
      case SET_SAVING_FLOW_FLAG_RESET:
         return {
            ...state,
            savingFlowFlagSuccess: false
         };
      case SET_SAVING_FLOW_PROPERTIES_FLAG_SUCCESS:
         return {
            ...state,
            savingFlowPropertiesFlagSuccess: true
         };
      case SET_SAVING_FLOW_PROPERTIES_FLAG_RESET:
         return {
            ...state,
            savingFlowPropertiesFlagSuccess: false
         };
      case SET_AUTO_SAVING_FLOW_FLAG_SUCCESS:
         return {
            ...state,
            autoSavingFlowFlagSuccess: true
         };
      case SET_AUTO_SAVING_FLOW_FLAG_RESET:
         return {
            ...state,
            autoSavingFlowFlagSuccess: false
         };
      case SET_FLOW:
         return {
            ...state,
            flow: { ...state.flow, ...payload.flow }
         };
      case CLEAR_FLOW:
         return {
            ...state,
            flow: {
               name: "",
               description: "",
               notes: "",
               variables: {},
               sensitiveData: [],
               steps: []
            }
         };
      case UPDATE_FLOW_STEPS: {
         const element = payload;
         let flow = Object.assign({}, state.flow);
         let flowEl = flow.steps.find((s) => s.elementId === element.elementId);

         if (flowEl) {
            flow.steps = flow.steps.filter((s) => s.elementId !== element.elementId);
            flowEl = {
               ...flowEl,
               component: element.component,
               action: element.action,
               data: element.data
            };
            flow.steps.push(flowEl);
         } else {
            flow.steps.push(element);
         }
         // sort flow elements by stepNumber
         flow.steps.sort((a, b) => {
            return a.stepNumber - b.stepNumber;
         });
         return {
            ...state,
            flow: { ...state.flow, steps: flow.steps }
         };
      }
      case OPEN_FLOW_LIST_DIALOG:
         return {
            ...state,
            showFlowListDialog: true
         };
      case CLOSE_FLOW_LIST_DIALOG:
         return {
            ...state,
            showFlowListDialog: false
         };
      case OPEN_RECENT_ACTIVITIES_DIALOG:
         return {
            ...state,
            showRecentActivitiesDialog: true
         };
      case CLOSE_RECENT_ACTIVITIES_DIALOG:
         return {
            ...state,
            showRecentActivitiesDialog: false
         };
      case AUTO_SAVE_ON_CANCEL_RESET:
         return {
            ...state,
            autoSaveOnCancel: false
         };
      case SET_CANVAS_FLOW_INSTANCE:
         return {
            ...state,
            canvasFlowInstance: payload
         };
      case SET_DESIGNER_FLOWS:
         return {
            ...state,
            flows: payload
         };
      case SET_DESIGNER_USER_FLOWS:
         return {
            ...state,
            userFlows: payload
         };
      case UPSERT_DESIGNER_USER_FLOWS:
         return {
            ...state,
            userFlows: [
               ...new Map(
                  [...state.userFlows, ...(payload ?? [])].map((userFlow) => [userFlow.id, userFlow])
               ).values()
            ]
         };
      case REMOVE_DESIGNER_USER_FLOWS: {
         const userFlowIds = new Set(payload ?? []);
         return {
            ...state,
            userFlows: state.userFlows.filter(({ id }) => !userFlowIds.has(id))
         };
      }
      case START_DRAG_COMPONENT:
         return {
            ...state,
            dragInProgress: true
         };
      case STOP_DRAG_COMPONENT:
         return {
            ...state,
            dragInProgress: false
         };
      case SET_NEW_TAB_FLAG:
         return {
            ...state,
            isNewTab: payload
         };
      case SET_SHARE_FLOW_FLAG_RESET:
         return {
            ...state,
            shareFlowFlagSuccess: false
         };
      case SET_SHARE_FLOW_FLAG_SUCCESS:
         return {
            ...state,
            shareFlowFlagSuccess: true
         };
      case SET_SCHEDULED_FLOW_FLAG:
         return {
            ...state,
            isScheduledFlow: payload
         };
      case OPEN_DUPLICATE_FLOW_DIALOG:
         return {
            ...state,
            showDuplicateFlowDialog: true
         };
      case CLOSE_DUPLICATE_FLOW_DIALOG:
         return {
            ...state,
            showDuplicateFlowDialog: false
         };
      case SET_NUMBER_OF_NODES_LIMIT_REACHED:
         return {
            ...state,
            numberOfNodesLimitReached: payload
         };
      case SET_COPIED_NODE:
         return {
            ...state,
            copiedNode: payload
         };
      case SET_CUT_NODE:
         return {
            ...state,
            cutNode: payload
         };
      case SET_IS_NOTES_DIALOG_OPEN:
         return {
            ...state,
            isNotesDialogOpen: payload
         };
      case SET_NODE_TO_ADD_NOTES:
         return {
            ...state,
            nodeToAddNotes: payload
         };
      case SET_DRAGGED_NODE:
         return {
            ...state,
            draggedNode: payload
         };
      case SET_USER_COMMENTS:
         return {
            ...state,
            user_comments: payload
         };
      case SET_IS_LOADING_USER_COMMENTS:
         return {
            ...state,
            isLoadingUserComments: payload
         };
      case SET_FLOW_VERSIONS:
         return {
            ...state,
            flowVersions: payload
         };
      case SET_FLOW_VERSIONS_IS_LOADING:
         return {
            ...state,
            isLoadingFlowVersions: payload
         };
      case SET_FLOW_IS_LOADING:
         return {
            ...state,
            isFlowLoading: payload
         };
      case RELOAD_FLOWS:
         return {
            ...state,
            reloadFlowsCount: ++state.reloadFlowsCount
         };

      case SET_FLOW_VERSIONS_DIALOG_OPEN:
         return {
            ...state,
            flowVersionsDialogOpen: payload
         };
      case SET_CREATE_FLOW_VERSION_DIALOG_OPEN:
         return {
            ...state,
            createFlowVersionDialogOpen: payload
         };
      case SET_DELETE_FLOW_VERSION_DIALOG_OPEN:
         return {
            ...state,
            deleteFlowVersionDialogOpen: payload
         };
      case SET_FLOW_VERSION_TO_DELETE:
         return {
            ...state,
            flowVersionToDelete: payload
         };
      case SET_CHANGE_FLOW_VERSION_DIALOG_OPEN:
         return {
            ...state,
            changeFlowVersionDialogOpen: payload
         };
      case SET_FLOW_VERSION_TO_USE:
         return {
            ...state,
            flowVersionToUse: payload
         };
      case SET_IS_CHANGING_FLOW_MODE:
         return {
            ...state,
            isChangingFlowMode: payload
         };
      case SET_FLOW_CONFIGURATION:
         return {
            ...state,
            flowConfiguration: payload
         };
      case SET_SHARED_FLOW_CONFIGURATIONS:
         return {
            ...state,
            sharedFlowConfigurations: payload
         };
   }
   return state;
};

export default flows;
